// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = (window as any).firebaseConfig;
const vapidKey = (window as any).vapidKey;

const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app);

function registerClient() {
  return getToken(messaging, {vapidKey});
}

function listenToNotifications() {
  onMessage(messaging, (payload) => {
    try {
      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: payload.notification.image
      });
    } catch (err) {
      console.debug('Notification not supported by browser, using service worker notifications...');

      navigator.serviceWorker.getRegistrations().then(registrations => {
        if (!registrations) {
          console.error('Notification could not be sent : no service worker registered');
          return;
        }

        const registration = registrations.find(reg => reg.scope && reg.scope.endsWith('firebase-cloud-messaging-push-scope'));
        if (!registration) {
          console.error('Notification could not be sent : no service worker matches scope');
          return;
        }

        registration.showNotification(payload.notification.title, {
          body: payload.notification.body,
          icon: '/favicon.webp'
        });
      });
    }
  });
}

listenToNotifications();

export default { messaging, registerClient };